import React, { useRef, useEffect } from 'react';
import sanitize from 'sanitize-html';

/** @summary 行程特色區塊 */
const FeatureContent = React.memo<{ features: string }>(function FeatureContent(props) {
    const featureBlock = useRef<HTMLDivElement>(null);
    const inWeb = '<script type="text/javascript"> window.inWeb = true;</script>';

    useEffect(() => {
        const range = document.createRange();
        const sanitizedFeature = sanitize(inWeb + props.features, {
            allowedTags: false,
            allowedAttributes: false,
        });
        // 切換行程時，清空原本的內容
        if (featureBlock?.current !== null) {
            featureBlock.current.innerHTML = '';
        }
        const featureBlockEle = featureBlock.current;

        if (featureBlockEle) {
            featureBlockEle.appendChild(range.createContextualFragment(sanitizedFeature));
        }
    }, [props.features]);

    if (!props.features) {
        return null;
    }

    return <div className="itinerary_feature" id="feature" ref={featureBlock} />;
});

export default FeatureContent;
